import HBanner from './HBanner'

HBanner.install = function (Vue) {
  Vue.component(HBanner.name, HBanner)
}

export default HBanner
